export const reportingRouteNames = {
  default: 'reporting-v2',
  google: 'reporting-google-v2',
  facebook: 'reporting-facebook-v2',
  attribution: 'attribution-v2',
  appointments: 'appointments-reports-v2',
  callStats: 'call-stats-v2',
  agent: 'agent-reporting-v2',
  customReport: 'reporting-custom',
  customReportCreate: 'reporting-custom-create',
  customReportView: 'reporting-custom-view-builder',
  customReportSchedule: 'reporting-custom-schedule',
  appointmentsOld: 'appointments-reports-old',
  auditReport: 'audit-report',
}
